import { render, staticRenderFns } from "./MastheadDesktopPrimaryNav.vue?vue&type=template&id=6ffaa97a&"
import script from "./MastheadDesktopPrimaryNav.vue?vue&type=script&lang=js&"
export * from "./MastheadDesktopPrimaryNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports